module.exports = __webpack_public_path__ + "static/research-42d9653359676c129c52cc4b9fa9bf6b.png";